import {
  Component,
  EventEmitter,
  Input,
  Output,
  ChangeDetectorRef,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
  AbstractControl,
} from '@angular/forms';
import { location, validFileTypes } from './add-candidate.config';
import { PersonaType } from '@constants/global.enum';
import { AddCandidateService } from './add-candidate.service';
import { GlobalErrorService } from '@services/global-error.service';
import {
  Candidate,
  CandidatesResponse,
  SkillResponse,
  hiringRequestDDValues,
} from './add-candidate.model';
import { DatePipe } from '@angular/common';
import { ToasterService } from '@services/toaster.service';
import { getSkillOptions } from './add-candidate.helper';
import { allowedKeys, LENGTH } from '@shared/config/allowedKeys.config';
import { VendorService } from '@services/vendor.service';
import { switchMap, Subscription } from 'rxjs';
import { noOnlyZerosValidator, validateNumberInput } from '@utils/validators';
import { sortArrayByKey } from './add-candidate.helper';
import { ErrorMessages, HIRING_REQUEST_TEXT } from '@constants/constants';
import { validateAndLimitToFiveDigits } from './add-candidate.helper';
import { DataService } from '@services/data.service';
import { experienceValidator, maxOverallExperienceValidator, restrictInvalidKeyPress } from '@utils/validators';
import { FileUploadService } from '@services/file-upload.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-add-candidate',
  templateUrl: './add-candidate.component.html',
  styleUrl: './add-candidate.component.scss',
})
export class AddCandidateComponent {
  @Input() candidateEmailId: string = '';
  @Input() candidateId: string = '';
  @Input() fieldsVisibility: string = '';
  @Input() hiringRequestId: string = '';
  @Input() jobTitle: string = '';
  @Input() jobLocation: string = '';
  @Input() edit: boolean = false;
  @Input() delete: boolean = false;
  @Output() candidateUpdated = new EventEmitter<Candidate>();
  @Output() updateState = new EventEmitter<boolean>();
  title = '';
  personaType = PersonaType;
  locationOptions = location;
  opened: boolean = false;
  popopOpened: boolean = false;
  isModalOpen: boolean = true;
  addCandidateForm!: FormGroup;
  isSubmitted: boolean = false;
  candidatesDetail: Candidate | null = null;
  candidateData: Candidate | null = null;
  getCandidateData: Candidate | null = null;
  maxLengthTwo = LENGTH.MAX_LENGTH_TWO;
  maxLengthTen = LENGTH.MAX_LENGTH_TEN;
  fileError: string | null = null;
  selectedFile: string | null = null;
  selectedAddFile: string | null = null;
  fileSize: string | null = null;
  dragResume = false;
  dragDocs = false;
  jdFilePath: string = '';
  jdResumePath: string = '';
  addDocPath: string = '';
  currentDate: Date = new Date();
  mandatorySkillOptions: hiringRequestDDValues[] = [];
  gthSkillOptions: hiringRequestDDValues[] = [];
  allowedKeys = allowedKeys;
 openForm: boolean = true;
 hiringRequestText= HIRING_REQUEST_TEXT; 
 resumeFileError: string | null = null;
 additionalFileError: string | null = null; 

 validateContactNumber = validateNumberInput;

 private primarySkillsSubscription: Subscription = new Subscription();
 private secondarySkillsSubscription: Subscription = new Subscription();
  constructor(
    public fb: FormBuilder,
    private errorHandler: GlobalErrorService,
    public addCandidateService: AddCandidateService,
    private toasterService: ToasterService,
    private cdr: ChangeDetectorRef,
    private vendorService: VendorService,
    private dataService: DataService,
    private fileUploadService: FileUploadService,
    private dialog: MatDialog,
  ) {
    this.locationOptions = location;
  }
  candidatesLoading = false;
  ngOnInit() {
    this.initializeForm();
    this.sortDropdownOptions();
    this.cdr.detectChanges(); // Manually trigger change detection
    this.primarySkillsSubscription = this.addCandidateForm.get('primarySkills')!.valueChanges.subscribe(() => {
      this.onPrimarySkillsChange();
    });
    this.secondarySkillsSubscription = this.addCandidateForm.get('secondarySkills')!.valueChanges.subscribe(() => {
      this.onSecondarySkillsChange();
    });
  }

  duplicateMessage: string = '';
  duplicateIsRestricted: boolean = false;
  duplicateSubmissions: {
    jobId: string;
    jobTitle: string;
    hiringManager: string;
    status: string;
    feedback: string;
    vendorName: string;
    submittedDate: string;
  }[] = [];
  @ViewChild('duplicateDialog') duplicateDialogTpl!: TemplateRef<any>;
  private duplicateDialogRef?: MatDialogRef<any>;  
  sortDropdownOptions() {
    this.locationOptions = sortArrayByKey(this.locationOptions, 'label');
    this.mandatorySkillOptions = sortArrayByKey(this.mandatorySkillOptions, 'label');
    this.gthSkillOptions = sortArrayByKey(this.gthSkillOptions, 'label');
 }
  ngOnDestroy() {
    if (this.primarySkillsSubscription) {
      this.primarySkillsSubscription.unsubscribe();
    }
    if (this.secondarySkillsSubscription) {
      this.secondarySkillsSubscription.unsubscribe();
    }
  }
  updateActions(isDelete: boolean) {
    if (isDelete) {
      this.delete = false;
    } else {
      this.edit = false;
    }
    this.updateState.emit(true);
  }

  truncateText(text: string, maxLength: number = 30): string {
    if (!text || text === 'null' || text === 'undefined') return 'N/A';
    return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
  }

  getTooltipText(text: string): string | null {
    if (!text || text === 'null' || text === 'undefined' || text.trim() === '') {
      return null;
    }
    return  text ;
  }

  ngOnChanges() {
    if (!this.opened) {
      this.isSubmitted = false;
      this.locationOptions = location;
      if (this.fieldsVisibility === 'VENDORREPOPENPOS') {
        this.filterLocationOptions();
      }
    }
    if (this.fieldsVisibility === 'VENDORREPOPENPOS' && this.edit) {
      this.getSkills();
    }
    this.title =
      this.fieldsVisibility === 'VENDORREPJOBDET'
        ? 'Edit Candidate Profile'
        : 'Add Candidate Profile';
    if (this.fieldsVisibility === 'VENDORREPJOBDET' && this.edit) {
      this.getSkills();
      this.fetchCandidates();
    }
    this.opened = this.edit;
    this.popopOpened = this.delete;
  }
  initializeForm() {
    this.addCandidateForm = this.fb.group(
      {
        candidateName: ['', [Validators.required]],
        emailId: ['', [Validators.required, Validators.email]],
        contactNumber: ['', [Validators.required, noOnlyZerosValidator()]],
        yearsOfExperience: ['', [Validators.required, Validators.pattern(/^[0-9]*\.?[0-9]+$/),maxOverallExperienceValidator(40),experienceValidator('yearsOfExperience','yearsOfRelevantExperience')]],// Adding maxOverallExperienceValidator
        yearsOfRelevantExperience: ['', [Validators.required, Validators.pattern(/^[0-9]*\.?[0-9]+$/), maxOverallExperienceValidator(40),experienceValidator('yearsOfExperience','yearsOfRelevantExperience')]],// Adding relevantExperienceValidator
        location: ['', [Validators.required]],
        earliestAvailability: ['', [Validators.required, this.dateValidator]],
        primarySkills: ['', [Validators.required]],
        secondarySkills: [''],
        resumePath: ['', [Validators.required]],
        additionalDocumentsPath: ['', [Validators.required]],
        url: [
          '',
          [
            Validators.required,
            Validators.pattern(
              /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)([\/\w-]*)*(\?[^\s]*)?$/,
            ),
          ],
        ],
      },
      { validators: experienceValidator('yearsOfExperience','yearsOfRelevantExperience')},
    );
    this.addCandidateForm.get('yearsOfExperience')?.valueChanges.subscribe(() => {
      this.addCandidateForm.get('yearsOfRelevantExperience')?.updateValueAndValidity();
    });
  }

  handleFieldChange(event: Event, fieldName: string): void {
    validateAndLimitToFiveDigits(event, this.addCandidateForm, fieldName);
  }

  dateValidator(control: AbstractControl) {
    if (!control.value) {
      return null;
    }
    const selectedDate = new Date(control.value);
    if (isNaN(selectedDate.getTime())) {
      return { invalidDateFormat: true };
    }
    // Allow an existing (pre-filled, untouched) DOJ through on edit even if it
    // is now in the past; only enforce "today or later" when the user picks a date.
    if (!control.dirty) {
      return null;
    }
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return selectedDate < today ? { invalidDate: true } : null;
  }
  preventInvalidKeyPress(event: KeyboardEvent) {
    restrictInvalidKeyPress(event);
  }
  allowNumbersOnly(event: KeyboardEvent) {
    const key = event.key;
    if (key && (key < '0' || key > '9') && !allowedKeys.includes(key)) {
      event.preventDefault();
    }
  }
  filterLocationOptions() {
    const allowedLocations = this.jobLocation?.split(',')?.map(loc => loc.trim());
    this.locationOptions = this.locationOptions?.filter(loc => allowedLocations?.includes(loc.label));
  }
  fetchCandidates() {
    this.candidatesLoading = true;
    this.addCandidateService.getCandidateInfo(this.candidateId).subscribe(
      (res: CandidatesResponse) => {
        this.candidatesDetail = res.data;
        this.populateForm();
        this.cdr.detectChanges(); 
      },
      (error) => {
        this.errorHandler.logComponentError(error);
      },
    );
  }
  private extractFileName(path: string | undefined): string | null {
    if (!path) return null;
    const slashName = path.split('/').pop();
    if (!slashName) return null;
    if (slashName.includes('_')) {
      const parts = slashName.split('_');
      return parts[parts.length - 1] || slashName;
    }
        return slashName;
  }
  populateForm() {
    let selectedPrimarySkills = this.mandatorySkillOptions?.filter((option) =>
      this.candidatesDetail?.candidateSkills?.some(
        (skill) =>
          skill.primarySkills &&
          Number(skill.categoryId) === Number(option.value),
      ),
    );
    if (this.candidatesDetail?.resumePath) {
      const fileName = this.extractFileName(this.candidatesDetail.resumePath);
      if (fileName) {
        this.selectedFile = fileName;
        this.jdResumePath = this.candidatesDetail.resumePath;
      }
    }
    if (this.candidatesDetail?.additionalDocumentsPath) {
      const fileName = this.extractFileName(this.candidatesDetail.additionalDocumentsPath);
      if (fileName) {
        this.selectedAddFile = fileName;
        this.addDocPath = this.candidatesDetail.additionalDocumentsPath;
      }
    }
    let selectedGthSkill = this.gthSkillOptions?.filter((option) =>
      this.candidatesDetail?.candidateSkills?.some(
        (skill) =>
          skill.secondarySkills &&
          Number(skill.categoryId) === Number(option.value),
      ),
    );
    const selectedJobLocation = this.locationOptions.find(
      (loc) => loc.value === this.candidatesDetail?.location[0] || loc.label === this.candidatesDetail?.location[0],
    );
    this.addCandidateForm.patchValue({
      primarySkills: selectedPrimarySkills,
      secondarySkills: selectedGthSkill,
      candidateName: this.candidatesDetail?.candidateName ?? '',
      contactNumber: this.candidatesDetail?.contactNumber ?? '',
      emailId: this.candidatesDetail?.emailId ?? '',
      yearsOfExperience: this.candidatesDetail?.yearsOfExperience ?? '',
      yearsOfRelevantExperience:
        this.candidatesDetail?.yearsOfRelevantExperience ?? '',
      location: selectedJobLocation,
      earliestAvailability: this.candidatesDetail?.earliestAvailability ?? '',
      resumePath: this.candidatesDetail?.resumePath ?? '',
      additionalDocumentsPath:
        this.candidatesDetail?.additionalDocumentsPath ?? '',
      url: this.candidatesDetail?.url ?? '',
      status: this.candidatesDetail?.status ?? '',
    });
    this.candidatesLoading = false;
  }
  getCandidateInfor() {
    this.clearFileErrors();
    this.isSubmitted = false;
    this.opened = true;
  }
  isFieldValid(fieldName: string): boolean {
    const control = this.addCandidateForm.get(fieldName);
    if (this.isSubmitted || control?.touched) {
      return control?.valid ?? false;
    }
    return true;
  }
  private readonly fieldLabels: { [key: string]: string } = {
    candidateName: "candidate's name",
    emailId: 'email address',
    contactNumber: 'contact number',
    yearsOfExperience: 'total experience',
    yearsOfRelevantExperience: 'relevant experience',
    location: 'location',
    earliestAvailability: 'tentative date of joining',
    primarySkills: 'primary skill',
    secondarySkills: 'secondary skill',
    resumePath: 'resume',
    additionalDocumentsPath: 'screening feedback',
    url: 'URL',
  };

  getFieldError(fieldName: string): string {
    const control = this.addCandidateForm.get(fieldName);
    if (!control?.errors) return '';
    const errors = control.errors;
    const label = this.fieldLabels[fieldName] || 'value';

    if (errors['required']) {
      if (fieldName === 'location' || fieldName === 'primarySkills' || fieldName === 'secondarySkills') {
        return `Please select a ${label}.`;
      }
      if (fieldName === 'earliestAvailability') {
        return 'Please choose the tentative date of joining.';
      }
      if (fieldName === 'resumePath') return 'Please upload a resume.';
      if (fieldName === 'additionalDocumentsPath') return 'Please upload the screening feedback.';
      return `Please enter the ${label}.`;
    }
    if (errors['email']) {
      return 'Please enter a valid email address.';
    }
    if (errors['minlength']) {
      return `${label.charAt(0).toUpperCase() + label.slice(1)} must be at least ${errors['minlength'].requiredLength} characters.`;
    }
    if (errors['pattern']) {
      if (fieldName === 'url') {
        return 'Please enter a valid URL (e.g. https://example.com).';
      }
      if (fieldName === 'yearsOfExperience' || fieldName === 'yearsOfRelevantExperience') {
        return 'Enter experience as a number (e.g. 5 or 5.5).';
      }
    }
    if (errors['invalidDate']) {
      return 'Date of joining must be today or later.';
    }
    if (errors['invalidDateFormat']) {
      return 'Please enter a valid date.';
    }
    if (errors['invalidFileType']) {
      return 'Only PDF or Word documents are allowed.';
    }
    if (errors['fileTooLarge']) {
      return 'File exceeds the 10 MB limit.';
    }
    return '';
  }

  submit() {
    this.isSubmitted = true;
    if (this.addCandidateForm.invalid) {
      this.addCandidateForm.markAllAsTouched();
      this.toasterService.showError(
        'Please complete the required fields highlighted below before saving.',
        'Error',
      );
      return;
    }
    const payload = {
      email: this.getFormValue('emailId'),
      mobileNumber: this.getFormValue('contactNumber'),
      labelName: 'add',
    };

    this.addCandidateService.validateProfile(payload).subscribe({
      next: () => {
        this.proceedSubmission();
      },
      error: (err) => {
        const responseStatus = err?.error?.status;
        const data = err?.error?.data;
        const isDuplicate =
          responseStatus === 'DUPLICATE' || !!(data?.duplicateFound || err?.error?.duplicateFound);
        if (isDuplicate) {
          const messageSource = err?.error?.message || data?.message;
          this.duplicateMessage = messageSource || 'Duplicate profile detected.';
          this.duplicateIsRestricted = !!(data?.isRestricted ?? err?.error?.isRestricted);
          this.duplicateSubmissions = Array.isArray(data?.submissions) ? data.submissions : [];
          this.duplicateDialogRef = this.dialog.open(this.duplicateDialogTpl, {
            width: '720px',
            maxWidth: '90vw',
            panelClass: 'center-dialog',
          });
          this.duplicateDialogRef.afterClosed().subscribe((result: any) => {
            if (result?.override) {
              this.proceedSubmission();
            }
          });
        } else {
          this.toasterService.showError(err?.error?.message || 'Validation failed', 'Error');
        }
      },
    });
  }

  private proceedSubmission() {
    this.vendorService.currentVendor$
      .pipe(
        switchMap((currentVendor: any) => {
          const vendorId = currentVendor.id;
          this.getCandidateData = this.constructCandidateData(vendorId);
          if (this.fieldsVisibility === 'VENDORREPJOBDET') {
            this.updateCandidateInfo(this.getCandidateData);
            this.candidateUpdated.emit(this.getCandidateData);
          } else {
            this.addCandidateInfo(this.getCandidateData);
          }
          return [];
        }),
      )
      .subscribe();
  }

  closeDuplicateDialog() {
    if (this.duplicateDialogRef) {
      this.duplicateDialogRef.close({ override: false });
    }
    this.duplicateMessage = '';
    this.duplicateSubmissions = [];
    this.duplicateIsRestricted = false;
  }

  overrideAndSubmit() {
    if (this.duplicateDialogRef) {
      this.duplicateDialogRef.close({ override: true });
    }
  }
  getFormValue(controlName: string) {
    return this.addCandidateForm.get(controlName)?.value;
  }
  constructCandidateData(vendorId?: number) {
    const userProfile = this.dataService.userProfile();
    const createdBy= this.fieldsVisibility === PersonaType.VendorRepJobDet ? this.candidatesDetail?.createdBy : userProfile.email;
    const updatedBy= this.fieldsVisibility === PersonaType.VendorRepJobDet ? userProfile.email:null;
    const candidateName = this.getFormValue('candidateName');
    const contactNumber = this.getFormValue('contactNumber');
    const emailId = this.getFormValue('emailId');
    const yearsOfExperience = this.getFormValue('yearsOfExperience');
    const yearsOfRelevantExperience = this.getFormValue(
      'yearsOfRelevantExperience',
    );
    const location = Array.isArray(this.getFormValue('location'))
      ? this.getFormValue('location').map(
          (loc: hiringRequestDDValues) => loc.value,
        )
      : [this.getFormValue('location').value];
    const jobTitle = this.getFormValue('jobTitle');
    const earliestAvailability = this.getFormValue('earliestAvailability');
    const resumePath = this.getFormValue('resumePath');
    const additionalDocumentsPath = this.getFormValue(
      'additionalDocumentsPath',
    );
    const url = this.getFormValue('url');
    const date = new Date(earliestAvailability);
    const datePipe = new DatePipe('en-US');
    const formattedDate = datePipe.transform(date, 'yyyy-MM-dd');
    const formValues = this.addCandidateForm.value;
    const candidateSkills = [
      ...formValues.primarySkills?.map((skill: hiringRequestDDValues) => ({
        categoryId: Number(skill.value),
        primarySkills: true,
        secondarySkills:
          formValues.secondarySkills?.some(
            (gthSkill: hiringRequestDDValues) => gthSkill.value === skill.value,
          ) || false,
      })),
      ...formValues.secondarySkills
        ?.filter(
          (skill: hiringRequestDDValues) =>
            !formValues.primarySkills?.some(
              (mSkill: hiringRequestDDValues) => mSkill.value === skill.value,
            ),
        )
        ?.map((skill: hiringRequestDDValues) => ({
          categoryId: Number(skill.value),
          primarySkills: false,
          secondarySkills: true,
        })),
    ];
    return {
      candidateSkills: candidateSkills,
      candidateName: candidateName,
      contactNumber: contactNumber,
      emailId: emailId,
      yearsOfExperience: yearsOfExperience,
      yearsOfRelevantExperience: yearsOfRelevantExperience,
      location: location,
      jobTitle: jobTitle,
      earliestAvailability: formattedDate ?? '',
      resumePath: resumePath ? resumePath : this.jdResumePath,
      additionalDocumentsPath: additionalDocumentsPath
        ? additionalDocumentsPath
        : this.addDocPath,
      url: url,
      status: this.candidatesDetail?.status ?? '',
      receivedOn: this.candidatesDetail?.receivedOn ?? '',
      position: this.candidatesDetail?.position ?? '',
      hiringManager: this.candidatesDetail?.hiringManager ?? '',
      hiringRequestId:
        Number(this.candidatesDetail?.hiringRequestId) ||
        Number(this.hiringRequestId),
      candidateId: Number(this.candidatesDetail?.candidateId) ?? 0,
      vendorId,
      createdBy,
      updatedBy,
    };
  }
  addCandidateInfo(getCandidateData: Candidate) {
    this.addCandidateService.addCandidateInfo(getCandidateData).subscribe(
      (_res) => {
        let successMessage = 'Candidate Information updated successfully!';
        this.toasterService.showSuccess(successMessage, 'Success');
        this.addCandidateForm.reset();
        this.opened = false;
        window.location.reload();
      },
      (error) => {
        this.toasterService.showError(error.error.message, 'Error');
      },
    );
  }
  updateCandidateInfo(getCandidateData: Candidate) {
    this.addCandidateService.updateCandidateInfo(getCandidateData).subscribe(
      (_res) => {
        let successMessage = 'Candidate Information submitted successfully!';
        this.toasterService.showSuccess(successMessage, 'Success');
        this.addCandidateForm.reset();
        window.location.reload();
        this.opened = false;
      },
      (error) => {
        this.toasterService.showError(error.error.message, 'Error');
      },
    );
  }
  handleDelete() {
    this.popopOpened = true;
  }
  clearFileErrors(): void {
    this.fileError = this.fileError !== undefined ? null : this.fileError;
    this.resumeFileError = this.resumeFileError !== undefined ? null : this.resumeFileError;
    this.additionalFileError = this.additionalFileError !== undefined ? null : this.additionalFileError; 
    this.addCandidateForm.get('resumePath')?.setErrors(null);
    this.addCandidateForm.get('additionalDocumentsPath')?.setErrors(null);
  }
  onAdditilalFile(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      const fileType = file.type;
      const fileSizeInBytes = file.size;
      this.selectedAddFile = input.files[0].name;
  
      if (!validFileTypes.includes(fileType)) {
        this.additionalFileError =
          'Invalid file type. Please upload a PDF or Word document.';
        this.selectedAddFile = null;
        this.addCandidateForm
          .get('additionalDocumentsPath')
          ?.setErrors({ invalidFileType: true });
            input.value = '';
        return;
      }
      if (fileSizeInBytes > 10 * 1024 * 1024) {
        this.fileSize = Math.floor(fileSizeInBytes / (1024 * 1024)) + ' MB';
        this.additionalFileError =
          'File size exceeds the maximum allowed size of 10MB.';
        this.selectedAddFile = null;
        this.addCandidateForm
          .get('additionalDocumentsPath')
          ?.setErrors({ fileTooLarge: true });
            input.value = '';
        return;
      } else if (fileSizeInBytes > 1024) {
        this.fileSize = Math.floor(fileSizeInBytes / 1024) + ' KB';
        this.additionalFileError = null;
        this.addCandidateForm.get('additionalDocumentsPath')?.setErrors(null);
      }
  
      this.selectedAddFile = file.name;
      this.fileUploadService.uploadFile(file, 'job_description').subscribe(
        (res) => {
            if (res?.success && res?.filePath) {
            this.addDocPath = res?.filePath;
            this.addCandidateForm.get('additionalDocumentsPath')?.setValue(this.addDocPath);
          } else {
            this.toasterService.showError(res?.message || ErrorMessages.FileUploadFailed, 'Error');
            this.addDocPath = '';
            this.addCandidateForm.get('additionalDocumentsPath')?.setValue('');
            this.selectedAddFile = null;
          }
        },
        (error) => {
          this.toasterService.showError(error.error, 'Error');
          this.addDocPath = '';
          this.addCandidateForm.get('additionalDocumentsPath')?.setValue('');
          this.selectedAddFile = null;
        },
      );
    } else {
      if (!this.selectedAddFile) {
        this.fileError = ErrorMessages.NoFileSelected;
      }
    }
    input.value = '';
  }
  // ---- drag & drop (reuses the same handlers as click-select) ----
  onDragOver(event: DragEvent, which: 'resume' | 'docs'): void {
    event.preventDefault();
    if (which === 'resume') this.dragResume = true;
    else this.dragDocs = true;
  }

  onDragLeave(event: DragEvent, which: 'resume' | 'docs'): void {
    event.preventDefault();
    if (which === 'resume') this.dragResume = false;
    else this.dragDocs = false;
  }

  onDropResume(event: DragEvent): void {
    event.preventDefault();
    this.dragResume = false;
    const files = event.dataTransfer?.files;
    if (files && files.length) {
      this.onFileSelected({ target: { files, value: '' } } as unknown as Event);
    }
  }

  onDropDocs(event: DragEvent): void {
    event.preventDefault();
    this.dragDocs = false;
    const files = event.dataTransfer?.files;
    if (files && files.length) {
      this.onAdditilalFile({ target: { files, value: '' } } as unknown as Event);
    }
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      const fileType = file.type;
      const fileSizeInBytes = file.size;
      this.selectedFile = input.files[0].name;
  
      if (!validFileTypes.includes(fileType)) {
        this.resumeFileError =
          'Invalid file type. Please upload a PDF or Word document.';
        this.selectedFile = null;
        this.addCandidateForm.get('resumePath')?.setErrors({ invalidFileType: true });
        input.value = '';
        return;
      }
      if (fileSizeInBytes > 10 * 1024 * 1024) {
        this.fileSize = Math.floor(fileSizeInBytes / (1024 * 1024)) + ' MB';
        this.resumeFileError =
          'File size exceeds the maximum allowed size of 10MB.';
        this.selectedFile = null;
        this.addCandidateForm.get('resumePath')?.setErrors({ fileTooLarge: true });
        input.value = '';
        return;
      } else if (fileSizeInBytes > 1024) {
        this.fileSize = Math.floor(fileSizeInBytes / 1024) + ' KB';
        this.resumeFileError = null;
        this.addCandidateForm.get('resumePath')?.setErrors(null);
      }
  
      this.selectedFile = file.name;
      this.fileUploadService.uploadFile(file, 'job_description').subscribe(
        (res) => {
          if (res?.success && res?.filePath) {
            this.jdResumePath = res?.filePath;
            this.addCandidateForm.get('resumePath')?.setValue(this.jdResumePath);
          } else {
            this.toasterService.showError(res?.message || ErrorMessages.FileUploadFailed, 'Error');
            this.jdResumePath = '';
            this.addCandidateForm.get('resumePath')?.setValue('');
            this.selectedFile = null;
          }
        },
        (error) => {
          this.toasterService.showError(error.error, 'Error');
          this.jdResumePath = '';
          this.addCandidateForm.get('resumePath')?.setValue('');
          this.selectedFile = null;
        },
      );
    } else {
      if (!this.selectedFile) {
        this.fileError = ErrorMessages.NoFileSelected;
      }
    }
    input.value = '';
  }
  onDeleteAdditionalFile() {
    this.selectedAddFile = null;
    this.addCandidateForm.get('additionalDocumentsPath')?.setValue('');
    if (this.candidatesDetail) {
      this.candidatesDetail.additionalDocumentsPath = '';
    }
  }
  onDeleteFile() {
    if (this.candidatesDetail) {
      this.candidatesDetail.resumePath = '';
    }
    this.selectedFile = null;
    this.addCandidateForm.get('resumePath')?.setValue('');
  }
  onCancel() {
    this.initializeForm();
    this.clearFileErrors(); 
    this.selectedFile = null;
    this.selectedAddFile = null;
    this.jdResumePath = '';
    this.addDocPath = '';
    this.addCandidateForm.get('resumePath')?.setValue('');
    this.addCandidateForm.get('additionalDocumentsPath')?.setValue('');
    this.openForm = false;
    setTimeout(() => {
      this.openForm = true;
    }, 100);
    this.opened = false;
    this.cdr.detectChanges(); 
  }
  filterSecondarySkills() {
    const selectedPrimarySkills: hiringRequestDDValues[] = this.addCandidateForm.get('primarySkills') ? this.addCandidateForm.get('primarySkills')!.value : [];
    const selectedSecondarySkills: hiringRequestDDValues[] = this.addCandidateForm.get('secondarySkills') ? this.addCandidateForm.get('secondarySkills')!.value : [];
    if (this.mandatorySkillOptions) {
      this.gthSkillOptions = this.mandatorySkillOptions.filter(
        (skill) => !selectedPrimarySkills?.some((primarySkill) => primarySkill.value === skill.value)
      );
        const secondarySkillsNotInPrimary = selectedSecondarySkills.filter(
        (secondarySkill) => !this.gthSkillOptions?.some((skill) => skill.value === secondarySkill.value)
      );
      this.gthSkillOptions = [...secondarySkillsNotInPrimary, ...this.gthSkillOptions];
    }
  }
  
  filterPrimarySkills() {
    const selectedPrimarySkills: hiringRequestDDValues[] = this.addCandidateForm.get('primarySkills') ? this.addCandidateForm.get('primarySkills')!.value : [];
    const selectedSecondarySkills: hiringRequestDDValues[] = this.addCandidateForm.get('secondarySkills') ? this.addCandidateForm.get('secondarySkills')!.value : [];
    if (this.mandatorySkillOptions) {
      this.mandatorySkillOptions = this.mandatorySkillOptions.filter(
        (skill) => !selectedSecondarySkills?.some((secondarySkill) => secondarySkill.value === skill.value)
      );
        const primarySkillsNotInSecondary = selectedPrimarySkills.filter(
        (primarySkill) => !this.mandatorySkillOptions?.some((skill) => skill.value === primarySkill.value)
      );
      this.mandatorySkillOptions = [...primarySkillsNotInSecondary, ...this.mandatorySkillOptions,];
    }
  }
  
  onPrimarySkillsChange() {
    this.filterSecondarySkills();
  }
  onSecondarySkillsChange() {
    this.filterPrimarySkills();
  }
  
  getSkills() {
    this.addCandidateService.getSkillData().subscribe(
      (skillRes: SkillResponse) => {
        this.mandatorySkillOptions = getSkillOptions(skillRes);
        this.gthSkillOptions = getSkillOptions(skillRes);
        this.sortDropdownOptions();
      },
      (error) => {
        this.errorHandler.logComponentError(error);
      },
    );
  }
}
